import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 289.99 289.99", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m106.45 32.75a73.7 73.7 0 1 1 -73.7 73.7 73.79 73.79 0 0 1 73.7-73.7m0 180.15a105.89 105.89 0 0 0 62.72-20.57l97.66 97.67 23.17-23.17-97.66-97.66a106.36 106.36 0 1 0 -85.88 43.73" }));
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
